const DASH = '–';

const money = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const dayUtc = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeZone: 'UTC' });

export function formatMoney(value: number): string {
  return money.format(value);
}

export function formatPercent(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return DASH;
  return `${Math.round(rate * 100)}%`;
}

export function formatCount(value: number): string {
  return value.toLocaleString();
}

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateTime(value: string | null | undefined): string {
  const parsed = parse(value);
  return parsed ? dateTime.format(parsed) : DASH;
}

export function formatDate(value: string | null | undefined): string {
  const parsed = parse(value);
  return parsed ? date.format(parsed) : DASH;
}

// Mart days are UTC calendar days ('YYYY-MM-DD'); formatting them in the viewer's zone would shift
// a day for anyone east of Greenwich in the evening.
export function formatDay(ymd: string | null | undefined): string {
  if (!ymd) return DASH;
  const parsed = parse(`${ymd}T00:00:00Z`);
  return parsed ? dayUtc.format(parsed) : DASH;
}

export function formatName(profile: { firstName: string | null; lastName: string | null } | null): string {
  if (!profile) return DASH;
  const name = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
  return name || DASH;
}

export const dash = DASH;
